import {useMutation} from "@tanstack/react-query";
import {postResendEmailVerification} from "../services/postResendEmailVerification.service";

const useResendEmailVerification = () => {
  const {mutate, data, isSuccess, isError, error, isPending} = useMutation({
    mutationKey: ["resend-email-verification"],
    mutationFn: postResendEmailVerification,
  });

  return {
    resendVerification: mutate,
    data,
    isSuccess,
    isError,
    error,
    isPending,
  };
};

export default useResendEmailVerification;
